import StageDenver, { getServerSideProps } from './Denver';
export default StageDenver;
export { getServerSideProps };
